export function getQuotes() {
    return [
        {
            quote: 'The goal as a company is to have customer service that is not just the best but legendary.',
            author: 'Sam Walton, Founder of Wal-Mart'
        },
        {
            quote: 'Your most unhappy customers are your greatest source of learning.',
            author: 'Bill Gates'
        },
        {
            quote: 'It is not the strongest of the species that survives, nor the most intelligent, but the one most responsive to change.',
            author: 'Charles Darwin'
        },
        {
            quote: 'It is not the employer who pays the wages. Employers only handle the money. It is the customer who pays the wages.',
            author: 'Henry Ford'
        },
        {
            quote: 'Well done is better than well said.',
            author: 'Benjamin Franklin'
        },
        {
            quote: 'Spend a lot of time talking to customers face to face. You’d be amazed how many companies don’t listen to their customers.',
            author: 'Ross Perot'
        },
        {
            quote: 'Kind words can be short and easy to speak, but their echos are truly endless.',
            author: 'Mother Teresa'
        },
        {
            quote: 'If you do build a great experience, customers tell each other about that. Word of mouth is very powerful.',
            author: 'Jeff Bezos, CEO Amazon.com'
        },
        {
            quote: 'In the end, the customer doesn’t know, or care, if you are small or large as an organisation. She or he only focuses on the garment hanging on the rail in the store.',
            author: 'Giorgio Armani'
        },
        {
            quote: 'The customer experience is the next competitive battleground.',
            author: 'Jerry Gregoire, CIO, Dell Computers'
        },
        {
            quote: 'Customer satisfaction is worthless. Customer loyalty is priceless.',
            author: 'Jeffrey Gitomer'
        },
        {
            quote: 'Quality in a service or product is not what you put into it. It is what the client or customer gets out of it.',
            author: 'Peter Drucker'
        },
        {
            quote: 'Customers don’t expect you to be perfect. They do expect you to fix things when they go wrong.',
            author: 'Donald Porter, V.P. British Airways'
        },
        {
            quote: 'Good service is good business.',
            author: 'Siebel Ad'
        },
        {
            quote: 'There is a spiritual aspect to our lives – when we give we receive – when a business does something good for somebody, that somebody feels good about them!',
            author: 'Ben Cohen, Ben & Jerry’s'
        },
        {
            quote: 'The more you engage with customers the clearer things become and the easier it is to determine what you should be doing.',
            author: 'John Russell, President, Harley Davidson'
        },
        {
            quote: 'One of the deep secrets of life is that all that is really worth doing is what we do for others.',
            author: 'Lewis Carol'
        },
        {
            quote: 'Being on par in terms of price and quality only gets you into the game. Service wins the game.',
            author: 'Tony Allesandra'
        },
        {
            quote: 'You’ll never have a product or price advantage again. They can be easily duplicated, but a strong customer service culture can’t be copied.',
            author: 'Jerry Fritz'
        },
        {
            quote: 'Every great business is built on friendship.',
            author: 'JC Penney'
        },
        {
            quote: 'If we do not lay out ourselves in the service of mankind whom should we serve?',
            author: 'John Adams'
        },
        {
            quote: 'Rule 1: The customer is always right. Rule 2: If the customer is ever wrong, re-read Rule 1.',
            author: 'Stew Leonard, CEO Stew Leonard’s'
        },
        {
            quote: 'If you’re not serving the customer, your job is to be serving someone who is.',
            author: 'Jan Carlzon, ex-CEO SAP Group'
        },
        {
            quote: 'If you want to lift yourself up, lift up someone else.',
            author: 'Booker T. Washington'
        },
        {
            quote: 'In the world of Internet Customer Service, it’s important to remember your competitor is only one mouse click away.',
            author: 'Doug Warner'
        },
        {
            quote: 'Know what your customers want most and what your company does best. Focus on where those two meet.',
            author: 'Kevin Stirtz'
        },
        {
            quote: 'Loyal customers, they don’t just come back, they don’t simply recommend you, they insist that their friends do business with you.',
            author: 'Chip Bell, Founder Chip Bell Group'
        },
        {
            quote: 'Make a customer, not a sale.',
            author: 'Katherine Barchetti'
        },
        {
            quote: 'If you do build a great experience, customers tell each other about that. Word of mouth is very powerful.',
            author: 'Jeff Bezos, CEO Amazon.com'
        },
        {
            quote: 'Customer service is not a department, it’s everyone’s job.',
            author: 'Anonymous'
        },
        {
            quote: 'Make your product easier to buy than your competition, or you will find your customers buying from them, not you.',
            author: 'Mark Cuban'
        },
        {
            quote: 'If you do build a great experience, customers tell each other about that. Word of mouth is very powerful.',
            author: 'Jeff Bezos, CEO Amazon.com'
        },
        {
            quote: 'The interesting thing is when we design and architect a server, we don’t design it for Windows or Linux, we design it for both. We don’t really care, as long as we’re selling the one the customer wants.',
            author: 'Michael Dell'
        },
        {
            quote: 'A customer is the most important visitor on our premises, he is not dependent on us. We are dependent on him. He is not an interruption in our work. He is the purpose of it. He is not an outsider in our business. He is part of it . We are not doing him a favor by serving him. He is doing us a favor by giving us an opportunity to do so.',
            author: 'Mahatma Gandhi'
        },
        {
            quote: 'When people talk about successful retailers and those that are not so successful, the customer determines at the end of the day who is successful and for what reason.',
            author: 'Jerry Harvey'
        },
        {
            quote: 'It’s a very, very tough market. So unless you do a really good job, you buy the right products from the manufacturers, you service the customer, they keep coming back, they bring their friends in, it’s all about numbers, numbers,  numbers.',
            author: 'John Ilhan'
        },
        {
            quote: 'A lot of companies have chosen to downsize, and maybe that was the right thing for them. We chose a different path. Our belief was that if we kept putting great products in front of customers, they would continue to open their wa llets.',
            author: 'Steve Jobs'
        },
        {
            quote: 'If you work just for money, you’ll never make it, but if you love what you’re doing and you always put the customer first, success will be yours.',
            author: 'Ray Kroc'
        },
        {
            quote: 'For us, our most important stakeholder is not our stockholders, it is our customers. We’re in business to serve the needs and desires of our core customer base.',
            author: 'John Mackey'
        },
        {
            quote: 'We see our customers as invited guests to a party, and we are the hosts. It’s our job every day to make every important aspect of the customer experience a little bit better.',
            author: 'Jeff Bezos, CEO Amazon.com'
        },
        {
            quote: 'You’ve got to look for a gap, where competitors in a market have grown lazy and lost contact with the readers or the viewers.',
            author: 'Rupert Murdoch'
        },
        {
            quote: 'In our way of working, we attach a great deal of importance to humility and honesty; With respect for human values, we promise to serve our customers with integrity.',
            author: 'Azim Premji'
        },
        {
            quote: 'Customers don’t always know what they want. The decline in coffee-drinking was due to the fact that most of the coffee people bought was stale and they weren’t enjoying it. Once they tasted ours and experienced what we call “the  third place”.. a gathering place between home and work where they were treated with respect.. they found we were filling a need they didn’t know they had.',
            author: 'Howard Schultz, Chairman and CEO Starbucks'
        },
        {
            quote: 'Don’t try to tell the customer what he wants. If you want to be smart, be smart in the shower. Then get out, go to work and serve the customer!',
            author: 'Gene Buckley, President Sikorsky Aircraft'
        },
        {
            quote: 'The most important adage and the only adage is, the customer comes first, whatever the business, the customer comes first.',
            author: 'Kerry Stokes'
        },
        {
            quote: 'I won’t complain. I just won’t come back',
            author: 'Brown & Williamson Tobacco Ad'
        },
        {
            quote: 'Customer service is just a day in, day out ongoing, never ending, unremitting, persevering, compassionate, type of activity.',
            author: 'Leon Gorman, CEO L.L.Bean'
        },
        {
            quote: 'Every company’s greatest assets are its customers, because without customers there is no company.',
            author: 'Michael LeBoeuf, Author of: How to Win Customers and Keep Them for Life'
        },
        {
            quote: 'Excellent firms don’t believe in excellence – only in constant improvement and constant change.',
            author: 'Tom Peters'
        },
        {
            quote: 'Friendly makes sales – and friendly generates repeat business.',
            author: 'Jeffrey Gitomer'
        },
        {
            quote: 'Service, in short, is not what you do, but who you are. It is a way of living that you need to bring to everything you do, if you are to bring it to your customer interactions',
            author: 'Betsy Sanders'
        },
        {
            quote: 'Every contact we have with a customer influences whether or not they’ll come back. We have to be great every time or we’ll lose them.',
            author: 'Kevin Stirtz'
        },
        {
            quote: 'Here is a simple but powerful rule: always give people more than what they expect to get.',
            author: 'Nelson Boswell'
        },
        {
            quote: 'Customers today want the very most and the very best for the very least amount of money, and on the best terms. Only the individuals and companies that provide absolutely excellent products and services at absolutely excellent prices will survive.',
            author: 'Brian Tracy'
        },
        {
            quote: 'It helps a ton when you learn people’s names and don’t butcher them when trying to pronounce them.',
            author: 'Jerry Yang'
        },
        {
            quote: 'Statistics suggest that when customers complain, business owners and managers ought to get excited about it. The complaining customer represents a huge opportunity for more business.',
            author: 'Zig Ziglar'
        },
        {
            quote: 'I don’t do business with those who don’t make a profit because they can’t give the best service.',
            author: 'Richard Bach'
        },
        {
            quote: 'If you don’t genuinely like your customers, chances are they won’t buy.',
            author: 'Thomas Watson, former CEO IBM'
        },
        {
            quote: 'Merely satisfying customers will not be enough to earn their loyalty. Instead, they must experience exceptional service worthy of their repeat business and referral. Understand the factors that drive this customer revolution.',
            author: 'Rick Tate'
        },
        {
            quote: 'Men are rich only as they give. He who gives great service gets great rewards.',
            author: 'Elbert Hubbard'
        },
        {
            quote: 'Our mission statement about treating people with respect and dignity is not just words but a creed we live by every day. You can’t expect your employees to exceed the expectations of your customers if you don’t exceed the employees’ expectations of management.',
            author: 'Howard Schultz, CEO Starbucks Coffee'
        },
        {
            quote: 'People expect good service but few are willing to give it.',
            author: 'Robert Gateley'
        },
        {
            quote: 'Revolve your world around the customer and more customers will revolve around you.',
            author: 'Heather Williams'
        },
        {
            quote: 'The customer’s perception is your reality.',
            author: 'Kate Zabriskie, Author of: Customer Service Excellence: How to Deliver Value to Today’s Busy Customer'
        },
        {
            quote: 'Do what you do so well that they will want to see it again and bring their friends.',
            author: 'Walt Disney'
        },
        {
            quote: 'He profits, most who serves best.',
            author: 'Arthur F. Sheldon'
        },
        {
            quote: 'The longer you wait, the harder it is to produce outstanding customer service.',
            author: 'William H. Davidow'
        },
        {
            quote: 'The single most important thing to remember about any enterprise is that there are no results inside its walls. The result of a business is a satisfied customer.',
            author: 'Peter Drucker'
        },
        {
            quote: 'When the customer comes first, the customer will last.',
            author: 'Robert Half'
        },
        {
            quote: 'Right or wrong, the customer is always right.',
            author: 'Marshall Field'
        },
        {
            quote: 'Under promise and over deliver.',
            author: 'Toby Bloomberg'
        },
        {
            quote: 'Profit in business comes from repeat customers; customers that boast about your product and service, and that bring friends with them.',
            author: 'W. Edwards Deming'
        },
        {
            quote: 'Your customer doesn’t care how much you know until they know how much you care.',
            author: 'Damon Richards'
        },
        {
            quote: 'Every client you keep, is one less that you need to find.',
            author: 'Nigel Sanders'
        },
        {
            quote: 'If you make customers unhappy in the physical world, they might each tell 6 friends. If you make customers unhappy on the Internet, they can each tell 6,000 friends',
            author: 'Jeff Bezos'
        },
        {
            quote: 'The purpose of a business is to create a customer who creates customers',
            author: 'Shiv Singh'
        },
        {
            quote: 'It’s much harder to provide a great customer service than I would have ever realised. It’s much more art than science in some of these other areas and not just about the facts but about how you are conveying them.',
            author: 'David Yu, Chief Operating Officer, Betfair'
        },
        {
            quote: 'Nothing is so contagious as enthusiasm.',
            author: 'Samuel Taylor Coleridge'
        },
        {
            quote: 'Only a life lived in the service to others is worth living.',
            author: 'Albert Einstein'
        },
        {
            quote: 'Good customer service costs less than bad customer service.',
            author: 'Sally Gronow, Welsh Water'
        },
        {
            quote: 'Whether you are big or small, you cannot give good customer service if your employees don’t feel good about coming to work.',
            author: 'Martin Oliver, MD Kwik-Fit Financial Services'
        },
        {
            quote: 'If we keep doing what we’re doing, we’re going to keep getting what we’re getting.',
            author: 'Stephen Covey'
        },
        {
            quote: 'Everyone in an organization should be involved with customer service, not only are they feeling the customer but they are getting a feeling for what’s not working.',
            author: 'Penny Handscomb'
        },
        {
            quote: 'There are no traffic jams along the extra mile.',
            author: 'Roger Staubach'
        },
        {
            quote: 'Good leaders must first become good servants.',
            author: 'Robert Greenleaf'
        },
        {
            quote: 'We don’t want to push our ideas on to customers, we simply want to make what they want.',
            author: 'Laura Ashley'
        },
        {
            quote: 'A little experience often upsets a lot of theory.',
            author: 'S. Parkes Cadman'
        },
        {
            quote: 'Whatever your business is, talk to your customers and provide them with what they want. It makes sense.',
            author: 'Robert Bowman, CEO Major League Baseball Advanced Media'
        },
        {
            quote: 'You are serving a customer, not a life sentence. Learn how to enjoy your work.',
            author: 'Laurie McIntosh'
        },
        {
            quote: 'Your best customers leave quite an impression. Do the same, and they won’t leave at all.',
            author: 'SAP Ad'
        },
        {
            quote: 'Unless you have 100% customer satisfaction... you must improve.',
            author: 'Horst Schulz'
        },
        {
            quote: 'It starts with respect. If you respect the customer as a human being, and truly honor their right to be treated fairly and honestly, everything else is much easier.',
            author: 'Doug Smith'
        },
        {
            quote: 'An ounce of loyalty is worth a pound of cleverness.',
            author: 'Elbert Hubbard'
        },
        {
            quote: 'Customer service is not a department, it’s everyone’s job.',
            author: 'Anonymous'
        },
        {
            quote: 'There is only one boss. The customer. And he can fire everybody in the company from the chairman on down, simply by spending his money somewhere else.',
            author: 'Sam Walton, Founder of Wal-Mart'
        }
    ]
}